let numberFormat = function (inputNumber, decimal) {
  decimal = (typeof decimal !== 'undefined') ? decimal : 2
  return inputNumber.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
}

export { numberFormat }



// WEBPACK FOOTER //
// ./src/assets/js/numberFormat.js